"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useConceptOfferHintScrollEffects = void 0;
var _react = require("react");
const useConceptOfferHintScrollEffects = (dialogRef)=>{
    const infoBannerRef = /*#__PURE__*/ (0, _react.createRef)();
    const offerRef = /*#__PURE__*/ (0, _react.createRef)();
    const [offerStart, setOfferStart] = (0, _react.useState)(0);
    const [offerEnd, setOfferEnd] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        if (offerRef.current) {
            const { offsetHeight, offsetTop } = offerRef.current;
            setOfferStart(offsetTop);
            setOfferEnd(offsetTop + offsetHeight);
        }
    }, [
        offerRef
    ]);
    (0, _react.useEffect)(()=>{
        // dialogNode is now the scrollable MuiScopedCssBaseline-root
        // its parentElement is the MuiOriDialog-content
        const dialogNode = dialogRef.current;
        const infoBannerNode = infoBannerRef.current;
        const handleScroll = (event)=>{
            if (!infoBannerNode || !dialogNode) {
                return;
            }
            const target = event.currentTarget;
            if (!target) {
                return;
            }
            window.requestAnimationFrame(()=>{
                const { scrollTop } = target;
                let position;
                let top;
                const { offsetHeight: infoBannerHeight, parentElement: infoBannerParent } = infoBannerNode;
                if (scrollTop > offerStart && scrollTop < offerEnd - infoBannerHeight) {
                    position = 'fixed';
                    const { top: boundingRectTop } = dialogNode.getBoundingClientRect();
                    top = Math.floor(boundingRectTop);
                } else {
                    position = 'absolute';
                    top = 0;
                }
                const { style } = infoBannerNode;
                style.position = position;
                style.top = "".concat(top, "px");
                style.width = "".concat(infoBannerParent === null || infoBannerParent === void 0 ? void 0 : infoBannerParent.offsetWidth, "px");
            });
        };
        if (dialogNode && infoBannerNode) {
            dialogNode.addEventListener('scroll', handleScroll);
        }
        return ()=>{
            dialogNode === null || dialogNode === void 0 ? void 0 : dialogNode.removeEventListener('scroll', handleScroll);
        };
    }, [
        dialogRef,
        infoBannerRef,
        offerEnd,
        offerStart
    ]);
    return {
        infoBannerRef,
        offerRef
    };
};
exports.useConceptOfferHintScrollEffects = useConceptOfferHintScrollEffects;
